/**
 * HELPERS PARA ESTADÍSTICAS GLOBALES
 * Suma de todas las stats de todos los contratos
 */

import { calculatePaymentStats, classifyPayment } from "./paymentHelpers";

/**
 * Calcula estadísticas globales de múltiples contratos
 * Suma todos los pagos de todos los contratos y clasifica
 */
export const calculateGlobalPaymentStats = (contratos) => {
	if (!contratos || contratos.length === 0) {
		return {
			pagado: { count: 0, total: 0 },
			deuda: { count: 0, total: 0 },
			corriente: { count: 0, total: 0 },
			futuro: { count: 0, total: 0 },
			totalPagado: 0,
			totalAdeudado: 0,
			totalFuturo: 0,
			totalGeneral: 0,
			pagarAhoraPara: 0,
			pendienteLuego: 0,
			percentPagado: 0,
			percentAdeudado: 0,
			percentFuturo: 0,
			hayDeuda: false,
			cantidadContratos: 0,
		};
	}

	// Acumular todas las stats
	const globalStats = {
		pagado: { count: 0, total: 0 },
		deuda: { count: 0, total: 0 },
		corriente: { count: 0, total: 0 },
		futuro: { count: 0, total: 0 },
	};

	// Sumar stats de cada contrato
	contratos.forEach((contrato) => {
		if (contrato.pagos && contrato.pagos.length > 0) {
			const stats = calculatePaymentStats(contrato.pagos);
			globalStats.pagado.count += stats.pagado.count;
			globalStats.pagado.total += stats.pagado.total;
			globalStats.deuda.count += stats.deuda.count;
			globalStats.deuda.total += stats.deuda.total;
			globalStats.corriente.count += stats.corriente.count;
			globalStats.corriente.total += stats.corriente.total;
			globalStats.futuro.count += stats.futuro.count;
			globalStats.futuro.total += stats.futuro.total;
		}
	});

	// Calcular totales
	const totalPagado = globalStats.pagado.total;
	const totalAdeudado = globalStats.deuda.total + globalStats.corriente.total;
	const totalFuturo = globalStats.futuro.total;
	const totalGeneral = totalPagado + totalAdeudado + totalFuturo;

	// Calcular porcentajes
	const percentPagado = totalGeneral > 0 ? Math.round((totalPagado / totalGeneral) * 100) : 0;
	const percentAdeudado = totalGeneral > 0 ? Math.round((totalAdeudado / totalGeneral) * 100) : 0;
	const percentFuturo = totalGeneral > 0 ? Math.round((totalFuturo / totalGeneral) * 100) : 0;

	return {
		...globalStats,
		totalPagado,
		totalAdeudado,
		totalFuturo,
		totalGeneral,
		pagarAhoraPara: totalAdeudado,
		pendienteLuego: totalFuturo,
		percentPagado,
		percentAdeudado,
		percentFuturo,
		hayDeuda: globalStats.deuda.total > 0,
		cantidadContratos: contratos.length,
	};
};

/**
 * Ordena contratos por año (más reciente primero)
 */
export const sortContratosByYearDescending = (contratos) => {
	return [...contratos].sort((a, b) => {
		const yearA = parseInt(a.contractYear);
		const yearB = parseInt(b.contractYear);
		return yearB - yearA; // Descendente: 2025, 2024, 2023...
	});
};

/**
 * Ordena pagos por mes (enero primero, diciembre último)
 */
export const sortPaymentsByMonthAscending = (pagos) => {
	return [...pagos].sort((a, b) => {
		const dateA = new Date(a.date);
		const dateB = new Date(b.date);
		return dateA - dateB; // Ascendente: Enero, Febrero... Diciembre
	});
};

/**
 * Obtiene nombre del mes en número (1-12)
 */
export const getMonthNumber = (date) => {
	return new Date(date).getMonth() + 1; // 1 = Enero, 12 = Diciembre
};

export default {
	calculateGlobalPaymentStats,
	sortContratosByYearDescending,
	sortPaymentsByMonthAscending,
	getMonthNumber,
};